import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Table from 'react-bootstrap/Table';

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../context/SocketContext'
import { useHideMenu } from '../hooks/useHideMenu'
import { useGetPantallas } from '../hooks/useGetPantallas';
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'

import LoadingOverlay from '../components/LoadingOverlay'
import { UsuariosPermisos } from '../components/usuariosPermisos';
import { UsuariosRolesPantallas } from '../components/usuariosRolesPantallas';
import { UsuariosRoles } from '../components/usuariosRoles';
import { NoAcceso } from '../components/NoAcceso';



const pasarMayusculas= (ev) =>{
    ev.preventDefault();
    ev.target.defaultValue= ev.target.defaultValue.toUpperCase();
    ev.target.value= ev.target.value.toUpperCase();
}




const MySwal = withReactContent(Swal);

const sweet = ( title, html, icon ) =>{ MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000  }) }
const sweetConfirm = ( title, html, icon ) =>{  
    return MySwal.fire({ 
                    title, 
                    html, 
                    icon, 
                    confirmButtonText: 'Ok',
                    confirmButtonColor: 'LightSeaGreen',  
                    showCancelButton: true, 
                    cancelButtonColor: '#d33',  
                    cancelButtonText: 'Cancelar' 
                }) 
}


export const Usuarios = () => {

    let [usuario] = useState( getUsuarioStorage() );
    const entidad = usuario.entidad;
    const pantallas = useGetPantallas();

    const navigate = useNavigate();
    useEffect(() => {
        if(usuario.uidUsuario === null){
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate])
  
    
    useHideMenu(false);
    
    const { socket } = useContext( SocketContext );

    const [ isLoading, setIsLoading ] = useState(false);
    const [tab, setTab] = useState('usuarios');
    // const [verUsuario, setVerUsuario] = useState('');
    
    
    // tabla
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    let   [sortedBy, setSortedBy] = useState('usuario');
    let   [sortDirection, setSortDirection] = useState('asc');

    const datos={
        entidad,
        search : searchTerm || '',
        page: currentPage || '',
        itemsPerPage: itemsPerPage || '',
        sortedBy: sortedBy,
        sortDirection: sortDirection,
       
    }
  
    
  
    useEffect(() => {
      
        async function fetchData() {
            await socket.on('lista-Usuarios1', ( lista ) => {
                console.log("si estoy ewn lista ");
                setData( lista )
            })
        }

        fetchData();

        return () => {
            socket.off('lista-Usuarios1')
        }
    }, [socket])

  
   
    const handleSort = async (header) => {
        
        setSortedBy(header);
        const direction= sortDirection === 'asc' ? 'desc' : 'asc'
        setSortDirection( direction );
        datos.sortedBy= header;
        datos.sortDirection= direction;

        setIsLoading(true)
        socket.emit( 'lista-Usuario', datos, async ( lista ) => {
            setIsLoading(false)
            setData(lista);
        })
           
        
    }
   
    const inactivaUsuario = async (uidUsuario, accion) => {
        
        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la infromación', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la infromación', 'error');

        const act = accion === 1 ? "Activar" : "Inactivar";

        const confirmacion = await sweetConfirm( "Atención", `Esta seguro de ${act} el registro?`, "warning" ).then( (result) => {
            return (result);
        })
        
        if (!confirmacion.value) return false;

        datos.uidUsuario= uidUsuario;
        datos.accion= accion;
        
        setIsLoading(true)
        socket.emit( 'inactiva-Usuario', datos, ( res ) => {
            setIsLoading(false)
            console.log( res )
        })

    }

    const registraUsuario = async ( uidUsuario ) => {

        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la información', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la información', 'error');

        datos.nombreCompleto    = document.getElementById(`nombreCompleto_${uidUsuario}`).value.toUpperCase();
        datos.usuario           = document.getElementById(`usuario_${uidUsuario}`).value.toUpperCase();
        datos.password          = document.getElementById(`password_${uidUsuario}`).value.toUpperCase();
        
        const registros = document.querySelectorAll('.registro');
        
        registros.forEach((elemento, index) => {
            if( elemento.value === "" ) return sweet('Atención!', 'Revise la información', 'error');
            if( elemento.value < 0    ) return sweet('Atención!', 'Revise la información', 'error');
        });

        
        setIsLoading(true)
        socket.emit( 'registra-Usuario', datos, async ( res ) => {
            setIsLoading(false)
            console.log(res)
            if( res[0] === ""){
                sweet('Atención!', res[1], 'error');
            }else if( res[0] === 1){
                sweet('', res[1], 'success');
                
                registros.forEach((elemento, index) => {
                    if( elemento.type !== "checkbox" ) elemento.value = ""
                    else elemento.checked= false;
                    delete datos[elemento.id.split("_")[0]];
                })   
            }else{
                console.log(res);
            }

          

        })

        

    }

    const editaUsuario = async ( ev, uidUsuario) =>{

        const campo= ev.target.id.split("_")[0];
        const valor= ( ev.target.type === 'checkbox' ) ? ev.target.checked : ev.target.value;
        const valorAnterior= ( ev.target.type === 'checkbox' ) ? ev.target.checked : ev.target.defaultValue;
        
        
        if ( valor !== valorAnterior  ){
            
            if( campo === "password" ){
                const confirmacion = await sweetConfirm( "Atención", "Esta seguro de cambiar el password?", "warning" ).then( (result) => {
                    return (result);
                })
                
                if (!confirmacion.value) return false;
            }

            datos.campo = campo;
            datos.valor = valor;
            datos.uidUsuario = uidUsuario;
            
            setIsLoading(true)           
            socket.emit( 'edita-Usuario', datos, async ( res ) => {
                setIsLoading(false)
            
                console.log(res)
                if( res === null){
                    
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    ev.target.value = valorAnterior;
                    console.log(res)

                }else if( res[0] === ""){
                    
                    sweet('Atención!', res[1], 'error');
                    ev.target.value = valorAnterior;

                }else if( res[0] === 1){
                    
                    delete datos[campo];
                    delete datos[valor];
                    delete datos[uidUsuario];
                                           
                }else{
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    console.log(res);
                }
    
            })

        }

        
    }

        
    // **************************table
   
    const listaUsuarios = () =>{
        socket.emit( 'lista-Usuarios', datos, async ( lista ) => {
            setData(lista);
        })

        socket.off('lista-Usuarios');
    }
   
    useEffect(() => {

        listaUsuarios();
       
    }, [searchTerm, currentPage, itemsPerPage]);

    
   


    
    const handleSearch = (ev) => {
        setSearchTerm(ev.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const currentItems = data.slice(0, itemsPerPage);


    
    
   
    if( usuario.uidUsuario === null ) {
        return(<></>)
    }
    else if( !pantallas.includes("usuarios") ) {
        return( <NoAcceso /> )
    }else{

        return (
            <>
                {isLoading && <LoadingOverlay />}
                
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{minHeight:'100vh'}}>
                   
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={tab}
                        onSelect={(k) => setTab(k)}
                        className="mb-3 justify-content-end"
                        // variant="pills"
                    >
                        <Tab eventKey="usuarios" title="Usuarios">
                            {/* <div> */}

                                <div className='row'>
                                    <div className='col-lg-2 col-12 '>
                                        <button
                                            className='btn btn-success m-3'
                                            data-bs-toggle="collapse" 
                                            data-bs-target="#divAgregaUsuario"
                                        >
                                        Agregar Usuario
                                        </button> 
                                        
                                    </div>
                                </div>

                                <div id='divAgregaUsuario'  className='row border border-info rounded shadow p-3 collapse hide'>
                                    <Table responsive striped hover>
                                        <thead>
                                            <tr>
                                                <th width={'5%'}></th>
                                                <th width={'45%'}>Nombre Completo</th>
                                                <th width={'25%'}>Usuario</th>
                                                <th width={'25%'}>Password</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody   >

                                            <tr>
                                                
                                                <td  width={'5%'}>
                                                    <button
                                                        className='btn btn-sm btn-primary me-1'
                                                        onClick={ ()=> registraUsuario('') }
                                                    > 
                                                    <i className='fas fa-save'></i>
                                                    </button> 

                                                </td>
                                                
                                                <td width={'45%'}> 
                                                    <input
                                                        type='text'
                                                        className='form-control registro'
                                                        id='nombreCompleto_'
                                                    />
                                                </td>

                                                <td width={'25%'}> 
                                                    <input
                                                        type='text'
                                                        className='form-control registro'
                                                        id='usuario_'
                                                    />
                                                </td>

                                                <td width={'25%'}> 
                                                    <input
                                                        type='text'
                                                        className='form-control registro'
                                                        id='password_'
                                                    />
                                                </td>
                                                
                                                
                                            </tr>
                                        
                                        </tbody>
                                    </Table>

                                </div>

                                <hr />

                                <div className='row rounded shadow p-3'>

                                    <div className='col-12'>
                                        <div className='float-start col-lg-4 col-12 pagination'>
                                            <button
                                                className='btn btn-sm btn-secondary m-1'
                                                onClick={() => paginate(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                            {"<"}
                                            </button> 
                                            <button
                                                className='btn btn-sm btn-secondary m-1'
                                                onClick={() => paginate(currentPage + 1)}
                                                disabled={currentItems.length < itemsPerPage}
                                            >
                                            {">"}
                                            </button>
                                        </div>

                                        <div className=' float-end col-lg-4 col-12'>

                                            <input
                                                type='text'
                                                placeholder='Buscar...'
                                                className='form-control'
                                                maxLength={20}
                                                defaultValue={searchTerm}
                                                onChange={ (ev) => handleSearch(ev)}
                                            />

                                        </div>
                                    
                                    </div>

                                    <div className='col-12'>
                                        <Table responsive="md" striped hover style={{minWidth: 600}} className='max600'>
                                            <thead>
                                                <tr>
                                                    <th width={'5%'}></th>
                                                    <th width={'45%'} onClick={ () => handleSort('nombreCompleto') } >
                                                        Nombre Completo
                                                        {sortedBy === 'nombreCompleto' && sortDirection === 'asc' && '▲'}
                                                        {sortedBy === 'nombreCompleto' && sortDirection === 'desc' && '▼'}
                                                    </th>
                                                    
                                                    <th width={'25%'} onClick={ () => handleSort('usuario') } >
                                                        Usuario
                                                        {sortedBy === 'usuario' && sortDirection === 'asc' && '▲'}
                                                        {sortedBy === 'usuario' && sortDirection === 'desc' && '▼'}
                                                    </th>
                                                    
                                                    <th width={'25%'}>Password</th>

                                                </tr>
                                            </thead>
                                            
                                            <tbody width={'100%'}  >

                                            {
                                                
                                                currentItems.length === 0 
                                                ?   (   <tr>
                                                            <td width={'100%'} style= {{textAlign:'center'}}> No Hay Registros </td>
                                                        </tr>
                                                    )
                                                : 
                                                currentItems.map((item) => (

                                                    <tr key={item.uidUsuario}>
                                                        <td width={'5%'}>
                                                        
                                                            {   (item.indActivo=== 1) 
                                                                ?(
                                                                    <>
                                                                        <button
                                                                            className='btn btn-sm btn-danger'
                                                                            onClick={() => inactivaUsuario( item.uidUsuario, 0 ) }
                                                                        > 
                                                                            <i className='fa-solid fa-minus'></i>
                                                                        </button>{' '}
                                                                        {/* <button
                                                                            className='btn btn-sm btn-success'
                                                                            onClick={() => permisosUsuario( item.uidUsuario ) }
                                                                        > 
                                                                            <i className="fa-solid fa-lock"></i>
                                                                        </button> */}
                                                                    </>
                                                                )
                                                                :(
                                                                    <button
                                                                        className='btn btn-sm btn-success'
                                                                        onClick={() => inactivaUsuario( item.uidUsuario, 1 ) }
                                                                    > 
                                                                    <i className='fa-solid fa-plus'></i>
                                                                    </button>
                                                                )
                                                            
                                                            }
                                                            


                                                        </td>
                                                        <td width={'45%'}> 
                                                            <input
                                                                type='text'
                                                                className='form-control'
                                                                id={`nombreCompleto_${item.uidUsuario}`}
                                                                defaultValue={item.nombreCompleto.toUpperCase()}
                                                                maxLength={200}
                                                                onBlur={ (ev) => editaUsuario( ev, item.uidUsuario)}
                                                                onChange={ (ev) => pasarMayusculas( ev )}
                                                            />
                                                        </td>
                                                        <td width={'25%'}> 
                                                            <input
                                                                type='text'
                                                                className='form-control'
                                                                id={`usuario_${item.uidUsuario}`}
                                                                defaultValue={item.usuario.toUpperCase()}
                                                                maxLength={20}
                                                                readOnly 
                                                            />
                                                        </td>
                                                        <td width={'25%'}> 
                                                            <input
                                                                type='text'
                                                                className='form-control'
                                                                id={`password_${item.uidUsuario}`}
                                                                onBlur={ (ev) => editaUsuario( ev, item.uidUsuario)}
                                                                maxLength={20}
                                                                
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                            </tbody>
                                        </Table>

                                        <div className='pagination'>
                                            <button
                                                className='btn btn-sm btn-secondary m-1'
                                                onClick={() => paginate(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                            {'<'}
                                            </button> 
                                            <button
                                                className='btn btn-sm btn-secondary m-1'
                                                onClick={() => paginate(currentPage + 1)}
                                                disabled={currentItems.length < itemsPerPage}
                                            >
                                            {'>'}
                                            </button>
                                        </div>
                                    </div>

                                    
                                </div>

                                

                                            
                            {/* </div> */}
                        </Tab>
                        <Tab eventKey="roles" title="Roles">
                            <UsuariosRoles />
                        </Tab>
                        <Tab eventKey="usuariosRoles" title="Usuarios/Roles">
                            <UsuariosPermisos  
                                uidUsuario = { '' }
                                usuario= { usuario } />
                        </Tab>
                        <Tab eventKey="rolesPantallas" title="Roles/Pantallas">
                            <UsuariosRolesPantallas  
                                usuario= { usuario } />
                        </Tab>
                    </Tabs>    

                    
        
                    

                </div>    
            </>
        )
    }
}
